/**
 * BudgetItemService
 * Planned line items of a budget (nested route).
 * Route: api/budgets/{budgetId}/items
 */
export class BudgetItemService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetItemService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(budgetId, path) {
        const base = `${this.servicePath}/api/budgets/${budgetId}/items`;
        const url = path ? `${base}/${path}` : base;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** All planned line items of a budget. */
    async getByBudget(budgetId) {
        const response = await this.http.get(this.buildUrl(budgetId));
        return response.data ?? [];
    }
    /** Add a planned line item. */
    async create(budgetId, body) {
        const response = await this.http.post(this.buildUrl(budgetId), body);
        if (!response.data)
            throw new Error(`Failed to create item for budget ${budgetId}`);
        return response.data;
    }
    /** Update a planned line item (partial). */
    async update(budgetId, budgetItemId, body) {
        const response = await this.http.put(this.buildUrl(budgetId, String(budgetItemId)), body);
        if (!response.data)
            throw new Error(`Failed to update budget item ${budgetItemId}`);
        return response.data;
    }
    /** Delete a planned line item. */
    async delete(budgetId, budgetItemId) {
        const response = await this.http.delete(this.buildUrl(budgetId, String(budgetItemId)));
        return response.success;
    }
    /**
     * Spreadsheet import — rows already parsed and column-mapped CLIENT-SIDE
     * (SheetJS); the server never sees the file. Strict all-or-nothing: any
     * invalid row fails the whole import with rowErrors.
     */
    async import(budgetId, body) {
        const response = await this.importRaw(budgetId, body);
        if (!response.data)
            throw new Error(`Failed to import items for budget ${budgetId}`);
        return response.data;
    }
    importRaw(budgetId, body) {
        return this.http.post(this.buildUrl(budgetId, 'import'), body);
    }
}
BudgetItemService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetItemService.js.map